/**
 * @generated SignedSource<<a41c03ea431d78abcd5ef3903ca7e027>>
 * @relayHash 41fb06ab344f1b6e3b9e650d79996d31
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/581.0.0-2026-10-13T13:14:19.201Z/homepageDefaultRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserRecommendationType = "PERSONALIZED" | "PERSONALIZED_SIGLIP" | "%future added value";
export type homepageDefaultRootQuery$variables = {
  abTestList?: ReadonlyArray<string | null> | null;
  fetchInitialHomepage: boolean;
  hasUserId: boolean;
  homepageId: string;
  isMobile: boolean;
  isPersonalizedContentAboveFoldTestVariant: boolean;
  isRemoveTopHeroBannerTestVariant: boolean;
  isTrade: boolean;
  mixedGridFirst?: number | null;
  priceBookName: string;
  recommendationType: UserRecommendationType;
  userId: string;
  userType: string;
};
export type homepageDefaultRootQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"HpDefaultLayout_viewer" | "getHomePageMetaContent_viewer" | "isEmptyHomePage_viewer">;
  };
};
export type homepageDefaultRootQuery = {
  response: homepageDefaultRootQuery$data;
  variables: homepageDefaultRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": ([]/*:: as any*/),
  "kind": "LocalArgument",
  "name": "abTestList"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchInitialHomepage"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUserId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "homepageId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMobile"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPersonalizedContentAboveFoldTestVariant"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRemoveTopHeroBannerTestVariant"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v8 = {
  "defaultValue": 8,
  "kind": "LocalArgument",
  "name": "mixedGridFirst"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommendationType"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userType"
},
v13 = {
  "kind": "Variable",
  "name": "recommendationType",
  "variableName": "recommendationType"
},
v14 = {
  "kind": "Variable",
  "name": "abTestList",
  "variableName": "abTestList"
},
v15 = [
  (v14/*:: as any*/),
  {
    "kind": "Variable",
    "name": "rootId",
    "variableName": "homepageId"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = [
  {
    "kind": "RootArgument",
    "name": "abTestList"
  },
  {
    "kind": "RootArgument",
    "name": "homepageId"
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "HomepageMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v18/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v21 = {
  "kind": "Variable",
  "name": "userType",
  "variableName": "userType"
},
v22 = [
  (v21/*:: as any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cta",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v25/*:: as any*/)
  ],
  "storageKey": null
},
v27 = [
  (v18/*:: as any*/),
  {
    "alias": null,
    "args": (v22/*:: as any*/),
    "concreteType": "EditorialItem",
    "kind": "LinkedField",
    "name": "items",
    "plural": true,
    "selections": [
      (v23/*:: as any*/),
      (v18/*:: as any*/),
      (v24/*:: as any*/),
      (v26/*:: as any*/)
    ],
    "storageKey": null
  }
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v31 = [
  (v29/*:: as any*/),
  (v30/*:: as any*/)
],
v32 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v33 = [
  (v32/*:: as any*/)
],
v34 = {
  "condition": "hasUserId",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "userPortfolios",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "portfolioTypes",
          "value": [
            "HEART"
          ]
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "userIds.0",
              "variableName": "userId"
            }
          ],
          "kind": "ListValue",
          "name": "userIds"
        }
      ],
      "concreteType": "PortfoliosConnection",
      "kind": "LinkedField",
      "name": "portfolios",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfoliosEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PortfolioV2",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v31/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v33/*:: as any*/),
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v29/*:: as any*/),
        {
          "alias": "canShowStorefrontOnlyBadge",
          "args": [
            {
              "kind": "Literal",
              "name": "name",
              "value": "VIEW_STOREFRONT_ONLY_BADGE"
            }
          ],
          "kind": "ScalarField",
          "name": "hasPermission",
          "storageKey": "hasPermission(name:\"VIEW_STOREFRONT_ONLY_BADGE\")"
        },
        (v30/*:: as any*/)
      ],
      "storageKey": null
    }
  ]
},
v35 = [
  (v14/*:: as any*/),
  {
    "kind": "Variable",
    "name": "homepageId",
    "variableName": "homepageId"
  },
  {
    "kind": "Variable",
    "name": "isMobile",
    "variableName": "isMobile"
  },
  (v13/*:: as any*/),
  (v32/*:: as any*/),
  (v21/*:: as any*/)
],
v36 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "mixedGridFirst"
  }
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemSource",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v25/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
],
v41 = {
  "kind": "InlineFragment",
  "selections": [
    (v29/*:: as any*/),
    (v18/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "browseUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "categoryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ecommerceTrackingParams",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": (v31/*:: as any*/),
      "storageKey": null
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "heartPortfolioItems",
          "args": [
            {
              "kind": "Literal",
              "name": "portfolioType",
              "value": "HEART"
            },
            (v32/*:: as any*/)
          ],
          "concreteType": "PortfolioItemV2",
          "kind": "LinkedField",
          "name": "portfolioItems",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "portfolioId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "portfolioItemId",
              "storageKey": null
            },
            (v30/*:: as any*/)
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": "productPhotos",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "masterOrZoomPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "smallPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPhotoVersion",
          "kind": "LinkedField",
          "name": "versions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webPath",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v30/*:: as any*/)
      ],
      "storageKey": "photos(limit:1)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemMeasurement",
      "kind": "LinkedField",
      "name": "measurement",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "addLabel",
              "value": true
            },
            {
              "kind": "Literal",
              "name": "fields",
              "value": [
                "height",
                "width",
                "depth",
                "diameter",
                "length"
              ]
            },
            {
              "kind": "Literal",
              "name": "separator",
              "value": " "
            }
          ],
          "concreteType": "ItemDisplayMeasurementType",
          "kind": "LinkedField",
          "name": "display",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unit",
              "storageKey": null
            },
            (v38/*:: as any*/)
          ],
          "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSize",
          "kind": "LinkedField",
          "name": "size",
          "plural": false,
          "selections": [
            (v38/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemClassification",
      "kind": "LinkedField",
      "name": "classification",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creationDate",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Creator",
          "kind": "LinkedField",
          "name": "creator",
          "plural": false,
          "selections": [
            (v28/*:: as any*/),
            (v30/*:: as any*/)
          ],
          "storageKey": null
        },
        (v30/*:: as any*/)
      ],
      "storageKey": null
    },
    (v39/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isMultiSku",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRingItem",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttribute",
      "kind": "LinkedField",
      "name": "variableAttributes",
      "plural": true,
      "selections": [
        (v29/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "VariableAttributeSortType",
          "kind": "LinkedField",
          "name": "variableAttributeData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SwatchSort",
              "kind": "LinkedField",
              "name": "swatchSort",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Swatch",
                  "kind": "LinkedField",
                  "name": "swatch",
                  "plural": false,
                  "selections": [
                    (v29/*:: as any*/),
                    (v28/*:: as any*/),
                    (v23/*:: as any*/),
                    (v30/*:: as any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v30/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Literal",
          "name": "page",
          "value": "searchAndBrowse"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        }
      ],
      "concreteType": "ItemDisplayPriceType",
      "kind": "LinkedField",
      "name": "displayPrice",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "kind": "LinkedField",
          "name": "convertedAmountList",
          "plural": true,
          "selections": (v40/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "kind": "LinkedField",
          "name": "originalConvertedAmountList",
          "plural": true,
          "selections": (v40/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quantityDisplay",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percentageOff",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "textType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amountType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showPriceLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showPriceVariability",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentQuote",
      "kind": "LinkedField",
      "name": "shipmentQuotes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isComplimentary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCalculated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FinancialAmount",
          "kind": "LinkedField",
          "name": "totalAmount",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ConvertedAmounts",
              "kind": "LinkedField",
              "name": "convertedAmounts",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "USD",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ShipmentServiceMethod",
          "kind": "LinkedField",
          "name": "serviceMethod",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Region",
              "kind": "LinkedField",
              "name": "region",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "regionName",
                  "storageKey": null
                },
                (v30/*:: as any*/)
              ],
              "storageKey": null
            },
            (v30/*:: as any*/)
          ],
          "storageKey": null
        },
        (v30/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewDisplayType",
      "kind": "LinkedField",
      "name": "quickViewDisplay",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QuickViewParagraph",
          "kind": "LinkedField",
          "name": "paragraphs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            {
              "alias": "mobileText",
              "args": [
                {
                  "kind": "Literal",
                  "name": "formatType",
                  "value": "MOBILE"
                }
              ],
              "kind": "ScalarField",
              "name": "text",
              "storageKey": "text(formatType:\"MOBILE\")"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "QuickViewCreator",
          "kind": "LinkedField",
          "name": "creators",
          "plural": true,
          "selections": [
            (v28/*:: as any*/),
            (v39/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "QuickViewCategorySegments",
          "kind": "LinkedField",
          "name": "paragraphAttributeNames",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "period",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "origin",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "style",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "periodPrefix",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
},
v42 = {
  "kind": "InlineFragment",
  "selections": [
    (v30/*:: as any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": (v36/*:: as any*/),
  "filters": null,
  "handle": "connection",
  "key": "HpPersonalizedMixedGrid_items",
  "kind": "LinkedHandle",
  "name": "items"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      (v11/*:: as any*/),
      (v12/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "homepageDefaultRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "isPersonalizedContentAboveFoldTestVariant",
                "variableName": "isPersonalizedContentAboveFoldTestVariant"
              },
              {
                "kind": "Variable",
                "name": "mixedGridFirst",
                "variableName": "mixedGridFirst"
              },
              (v13/*:: as any*/)
            ],
            "kind": "FragmentSpread",
            "name": "HpDefaultLayout_viewer"
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "isEmptyHomePage_viewer",
            "selections": [
              {
                "alias": null,
                "args": (v15/*:: as any*/),
                "concreteType": "Homepage",
                "kind": "LinkedField",
                "name": "homepage",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "modules",
                    "plural": true,
                    "selections": [
                      (v16/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "args": null,
            "argumentDefinitions": (v17/*:: as any*/)
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "getHomePageMetaContent_viewer",
            "selections": [
              {
                "alias": null,
                "args": (v15/*:: as any*/),
                "concreteType": "Homepage",
                "kind": "LinkedField",
                "name": "homepage",
                "plural": false,
                "selections": [
                  (v19/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "args": null,
            "argumentDefinitions": (v17/*:: as any*/)
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*:: as any*/),
      (v3/*:: as any*/),
      (v1/*:: as any*/),
      (v11/*:: as any*/),
      (v2/*:: as any*/),
      (v12/*:: as any*/),
      (v0/*:: as any*/),
      (v6/*:: as any*/),
      (v5/*:: as any*/),
      (v10/*:: as any*/),
      (v7/*:: as any*/),
      (v9/*:: as any*/),
      (v8/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "homepageDefaultRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v15/*:: as any*/),
            "concreteType": "Homepage",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v16/*:: as any*/),
                  {
                    "condition": "isRemoveTopHeroBannerTestVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isHomepageUnionType"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v20/*:: as any*/),
                          {
                            "alias": null,
                            "args": (v22/*:: as any*/),
                            "concreteType": "TopHeroBannerMessages",
                            "kind": "LinkedField",
                            "name": "messages",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TopHeroBannerItem",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  {
                                    "condition": "isMobile",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      (v23/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "imageHeight",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "imageWidth",
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  {
                                    "condition": "isMobile",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mobileImageUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mobileImageHeight",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "mobileImageWidth",
                                        "storageKey": null
                                      }
                                    ]
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "HeroBannerSettingsType",
                                    "kind": "LinkedField",
                                    "name": "heroBannerSettings",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "eyeBrowText",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "headerText",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dekText",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "backgroundColor",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "contentColor",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v24/*:: as any*/),
                                  (v26/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "videoUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isMuxVideo",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "videoAutoplay",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mediaFormat",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "TopHeroBannerModule",
                        "abstractKey": null
                      }
                    ]
                  },
                  {
                    "condition": "fetchInitialHomepage",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v20/*:: as any*/),
                          {
                            "condition": "isPersonalizedContentAboveFoldTestVariant",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": (v27/*:: as any*/)
                          }
                        ],
                        "type": "EditorialModule",
                        "abstractKey": null
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v20/*:: as any*/)
                    ],
                    "type": "LocationsModule",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v20/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "visible",
                        "storageKey": null
                      },
                      (v18/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subText",
                        "storageKey": null
                      },
                      (v24/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "ctaLink",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "image",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mobileImage",
                        "storageKey": null
                      }
                    ],
                    "type": "BottomBannerModule",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v19/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "condition": "isRemoveTopHeroBannerTestVariant",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "muxMonitoringFF",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "muxMonitoring"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"muxMonitoring\")"
              }
            ]
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "OnSaleVertical",
            "kind": "LinkedField",
            "name": "onSaleVerticals",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "category",
                "storageKey": null
              },
              (v28/*:: as any*/),
              (v26/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "condition": "isPersonalizedContentAboveFoldTestVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "condition": "isMobile",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v34/*:: as any*/),
                  {
                    "condition": "isPersonalizedContentAboveFoldTestVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v35/*:: as any*/),
                        "concreteType": "HomepageMixedGrid",
                        "kind": "LinkedField",
                        "name": "homepageMixedGrid",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EditorialModule",
                            "kind": "LinkedField",
                            "name": "editorialModule",
                            "plural": false,
                            "selections": (v27/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v36/*:: as any*/),
                            "concreteType": "HomepageMixedGridItemsConnection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HomepageMixedGridItemsEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "HomepageMixedGridItemEntry",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v37/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "item",
                                        "plural": false,
                                        "selections": [
                                          (v16/*:: as any*/),
                                          (v41/*:: as any*/),
                                          (v42/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v16/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v43/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v44/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v45/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isMobile",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  (v34/*:: as any*/),
                  {
                    "condition": "isPersonalizedContentAboveFoldTestVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v35/*:: as any*/),
                        "concreteType": "HomepageMixedGrid",
                        "kind": "LinkedField",
                        "name": "homepageMixedGrid",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v36/*:: as any*/),
                            "concreteType": "HomepageMixedGridItemsConnection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HomepageMixedGridItemsEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "HomepageMixedGridItemEntry",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v37/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "item",
                                        "plural": false,
                                        "selections": [
                                          (v16/*:: as any*/),
                                          (v41/*:: as any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "cmsId",
                                                "storageKey": null
                                              },
                                              (v18/*:: as any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "header",
                                                "storageKey": null
                                              },
                                              (v23/*:: as any*/),
                                              (v24/*:: as any*/),
                                              (v26/*:: as any*/)
                                            ],
                                            "type": "EditorialItem",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "slot",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "HomepageMixedGridAdSlot",
                                            "abstractKey": null
                                          },
                                          (v42/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v16/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v43/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v44/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v45/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "isPersonalizedContentAboveFoldTestVariant",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v35/*:: as any*/),
                    "concreteType": "HomepageMixedGrid",
                    "kind": "LinkedField",
                    "name": "homepageMixedGrid",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v36/*:: as any*/),
                        "concreteType": "HomepageMixedGridItemsConnection",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HomepageMixedGridItemsEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HomepageMixedGridItemEntry",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "item",
                                    "plural": false,
                                    "selections": [
                                      (v16/*:: as any*/),
                                      (v42/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v16/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v43/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v44/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v45/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "hasUserId",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v33/*:: as any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Profile",
                        "kind": "LinkedField",
                        "name": "profile",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v30/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          (v30/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/581.0.0-2026-10-13T13:14:19.201Z/homepageDefaultRootQuery",
    "metadata": {},
    "name": "homepageDefaultRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6d6b577e52bec163be07691e65f55244";

export default node;
